module.exports = __webpack_public_path__ + "media/c1.28646323.mp4";